import { ContentType } from "@brookbush/database";
import type { Course } from "@brookbush/types";

import Image from "next/image";
import { memo } from "react";

import CourseInfoButton from "./CourseInfoButton";
import BookmarkButton from "~/components/BookmarkButton";
import ContentDates from "~/components/ContentDates";
import LikeButton from "~/components/LikeButton";
import ShareButton from "~/components/ShareButton";

const CourseHeader = ({ course }: { course: Course }) => {
	return (
		<div className="relative col-span-full laptop:col-span-7 flex w-full phablet:flex-row flex-col gap-3 laptop:gap-5">
			<div className="relative order-2 phablet:order-1 phablet:m-0 mt-2 aspect-video phablet:size-40 w-full shrink-0 overflow-hidden phablet:rounded-2xl rounded-xl border">
				<Image
					fill
					src={course.thumbnail?.url ?? "https://www.gravatar.com/avatar?d=mp"}
					className="object-cover object-top"
					alt={course.thumbnail?.alt ?? `${course.title} Thumbnail`}
				/>
			</div>

			<div className="order-1 phablet:order-2 -mt-1 flex flex-col justify-evenly gap-3 phablet:gap-1.5">
				<h1
					id="course-title"
					className="font-bold text-black text-xl sm:text-2xl lg:line-clamp-2 dark:text-slate-50"
				>
					{course.title}
				</h1>

				<ContentDates
					createdAt={course._createdAt}
					updatedAt={course._updatedAt}
					className="text-sm"
				/>

				<p className="mb-2 phablet:line-clamp-2 hidden">{course.description}</p>

				<div className="flex gap-4 phablet:gap-3">
					<ShareButton href={`/courses/${course.slug}`} id="course-share-btn" />

					<BookmarkButton
						contentId={course._id}
						contentType={ContentType.COURSE}
					/>

					<LikeButton contentType={ContentType.COURSE} contentId={course._id} />

					<CourseInfoButton />
				</div>
			</div>

			<p className="order-3 line-clamp-3 phablet:hidden">
				{course.description}
			</p>
		</div>
	);
};

export default memo(CourseHeader);
